import React from 'react';
import { TypeAnimation } from 'react-type-animation';

const Banner = () => {
    const googleapi = `${process.env.REACT_APP_WEBSITE_NAME}`
    console.log(googleapi)
    const baseUrl = `${process.env.REACT_APP_baseurl}`
    console.log(baseUrl)



    const url = `${baseUrl}/uc?export=download&id=${googleapi}`
    console.log(url)
    return (
        <div>
            <div className="relative bg-lime-600">
                <div className="absolute inset-x-0 bottom-0">
                    <svg
                        viewBox="0 0 224 12"
                        fill="currentColor"
                        className="w-full -mb-1 text-white"
                        preserveAspectRatio="none"
                    >
                        <path d="M0,0 C48.8902582,6.27314026 86.2235915,9.40971039 112,9.40971039 C137.776408,9.40971039 175.109742,6.27314026 224,0 L224,12.0441132 L0,12.0441132 L0,0 Z" />
                    </svg>
                </div>
                <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                    <div className="relative max-w-2xl sm:mx-auto sm:max-w-xl md:max-w-2xl sm:text-center">
                        <h2 className="mb-3 font-sans text-3xl lg:text-5xl text-center font-bold tracking-tight text-slate-100    heading">
                            Arif <span className="text-yellow-300">Ullah</span>
                        </h2>
                        <h3 className="mb-6 flex justify-center items-center font-sans text-2xl font-bold tracking-tight text-slate-100  sm:text-3xl sm:leading-none heading">
                            I'm a
                <span className="text-yellow-300 ml-2">
                                <TypeAnimation
                                    sequence={[
                                        "Front-End Developer", // Types 'One'
                                        1000, // Waits 1s
                                        "React Developer", // Deletes 'One' and types 'Two'
                                        2000, // Waits 2s
                                        "Full-Stack Web Developer",
                                        2000,
                                        "Back-End Developer",
                                        2000,
                                        // Types 'Three' without deleting 'Two'
                                        () => {
                                            console.log("Done typing!"); // Place optional callbacks anywhere in the array
                                        },
                                    ]}
                                    wrapper="div"
                                    cursor={true}
                                    repeat={Infinity}
                                />
                            </span>
                        </h3>
                        <p className="mb-7 text-base text-state-100 md:text-lg">

                        </p>
                        <div className="flex flex-wrap">

                            <div className='text-center'>
                                <a href="#contact-me" className="bg-violet-500 hover:bg-violet-600 active:bg-violet-700 focus:outline-none focus:ring focus:ring-violet-300 p-3 rounded-full text-gray-100">
                                    Contact Me
</a>
                            </div>
                            <div className='text-center'>
                                <a href={url} className="bg-violet-500 hover:bg-violet-600 active:bg-violet-700 focus:outline-none focus:ring focus:ring-violet-300 p-3 rounded-full text-gray-100">
                                    Download Resume
</a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};
// rel="noopener noreferrer"
//target="_blank" rel="noopener noreferrer" href= download

export default Banner;